import parse from "html-react-parser";
import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import { useAppApi, useAppContext } from "@/App";
import { RenderForm } from "@components/Forms/Render";
import { Awesome } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { CommonCard, ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function NoticeScreen() {
    const { t } = useTranslation();
    const params = useParams();
    const header = t("Уведомления");
    return (
        <DefaultLayout>{params.id ? <Edit id={params.id} header={header} /> : <List header={header} />}</DefaultLayout>
    );
}

function List({ header }) {
    const { t, i18n } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:notice:list"));
    const { setDelData } = useAppContext();

    if (!apiData) return;

    const headerTools = (
        <Link to={url_reverse("admin:notice:edit", { notice_id: "add" })} className="btn btn-sm btn-dark">
            <Awesome type="plus-circle" /> {t("Добавить")}
        </Link>
    );

    return (
        <ListingCard header={header} headerTools={headerTools}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>{t("Дата начала")}</th>
                        <th>{t("Дата окончания")}</th>
                        <th>{t("Уведомление RU")}</th>
                        <th>{t("Количество закрытий")}</th>
                        <th style={{ width: "6%" }} />
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o, i) => {
                        return (
                            <tr key={`object_list${i}`}>
                                <td>{o.date_start}</td>
                                <td>{o.date_finish}</td>
                                <td>{i18n.language === "ru_RU" ? parse(o.notice_ru) : parse(o.notice_en)}</td>
                                <td>{o.close_cnt}</td>
                                <td className="dmg-table-row-tools">
                                    <Link to={url_reverse("admin:notice:edit", { notice_id: o.id })}>
                                        <Awesome type="pencil" />
                                    </Link>{" "}
                                    <Awesome
                                        type="trash-o"
                                        color="red"
                                        onClick={() =>
                                            setDelData({
                                                url: url_reverse("api:notice:delete", { notice_id: o.id }),
                                            })
                                        }
                                    />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </ListingCard>
    );
}

function Edit({ id, header }) {
    const { apiData } = useAppApi(url_reverse("api:notice:edit", { notice_id: id }));

    if (!apiData) return;

    return (
        <CommonCard header={header}>
            <RenderForm backUrl={url_reverse("admin:notice:list")} />
        </CommonCard>
    );
}
